import DocProps from './DocProps';

export default DocProps;
